import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { withCurrentTime } from '../../../HOCS/withCurrentTime';
import { compose } from 'recompose';
import { Container } from './style';
import { getCurrentTimestamp } from '../../../../../Utils/timeConvertorHelper';
import { convertFormatToSeconds, isEmptyObject } from '../../../../../Utils';
import RepeatWorkout from '../../../GymTv/Repeat';
import GymTv from '../../../GymTv/LiveDisplay';
import WorkoutProgramme from '../../../GymTv/WorkoutProgramme';
import LeaderBoardsCarusel from '../../../../App/pages/LeaderBoardsCarusel/LeaderBoardsCarusel';
import { YoutubePlayer } from './YoutubePlayer';
import { convertWatchYoutubeLinkToEmbed } from '../utils';
import { Loading } from '../../../WithLoading/Loading';
import { modalTypes } from '../constants';
import { BetweenSlider } from './BetweenSlider';
import { subscribeToLiveGymTv } from '../../../../../Services/handleSocketConnection';
import { GymTvActionCreators } from '../../../../../Store/ActionCreators/GymTvActionCreators';

class GymTvChannelDisplay extends PureComponent {
    state = {
        previousClassIndex: null,
        nextClassIndex: null,
        currentClassIndex: null,
        currentDisplayItem: {},
        before: {
            time: 0,
            item: {},
        },
        after: {
            time: 0,
            item: {},
        },
        between: {},
        contentType: 0,
    };

    componentDidMount() {
        const CURRENT_CHANNEL_ID = this.props.match.params.channelId;
        this.props.getCurrentChannel(CURRENT_CHANNEL_ID, roomNumber => {
            subscribeToLiveGymTv(roomNumber, updateTrigger => {
                if (updateTrigger) window.location.reload();
            });
            this.props.getClassesByRoomNumber(roomNumber, () => this.setClassDisplay());
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentTime && prevProps.currentTime !== this.props.currentTime) this.checkClassDisplay();
    }

    /*
        Initial display settings
    */
    setClassDisplay = () => {
        const { classes, currentChannel } = this.props;
        const nowTime = getCurrentTimestamp();
        const currentClassIndex = classes.findIndex(_class => _class.start < nowTime && _class.end > nowTime);
        const startDisplay = convertFormatToSeconds(currentChannel.start_display);
        const endDisplay = convertFormatToSeconds(currentChannel.end_display);

        let nextClassIndex = null;
        let previousClassIndex = null;

        if (currentClassIndex !== -1) {
            if (classes.length > currentClassIndex + 1) nextClassIndex = currentClassIndex + 1; // ok
            if (currentClassIndex !== 0) previousClassIndex = currentClassIndex - 1; // ok

            this.setState(prevState => ({
                ...prevState,
                previousClassIndex,
                currentClassIndex,
                nextClassIndex,
                before: { time: convertFormatToSeconds(currentChannel.start_display), ...currentChannel.before },
                after: { time: convertFormatToSeconds(currentChannel.end_display), ...currentChannel.after },
                during: { ...currentChannel.during },
                currentDisplayItem: {
                    name: 'During',
                    contentType: 1,
                    ...currentChannel.during,
                    time: classes[currentClassIndex].end - nowTime,
                },
            }));
        } else {
            let currentDisplayItem = {};
            /*
                Find the nearest start time which i less than the current time
            */
            // for (let i = 0; i < classes.length; i++) {
            //     if (classes[i].end - nowTime <= 0 && classes[i].end - nowTime <= endDisplay) {
            //         currentDisplayItem = {
            //             name: 'After',
            //             contentType: 2,
            //             ...currentChannel.after
            //         };

            //         previousClassIndex = i === 0 ? null : i - 1;
            //         this.setState({ currentDisplayItem, previousClassIndex });
            //         break;
            //     }
            // }

            for (let i = 0; i < classes.length; i++) {
                if (nowTime > classes[i].start && nowTime > classes[i].end) continue;
                if (nowTime < classes[i].start) {
                    nextClassIndex = i;
                    previousClassIndex = i === 0 ? null : i - 1;
                    break;
                }
            }

            /*
                Identify what should be displayed right now (in case we are not within a class)
            */

            if (nextClassIndex && nextClassIndex !== 0) {
                if (classes[nextClassIndex].start - classes[nextClassIndex - 1].end < startDisplay + endDisplay) {
                    const newDisplayBeforeAfterDuration = ((startDisplay + endDisplay) / 2).toFixed(0);

                    if (classes[nextClassIndex].start - nowTime > nowTime - classes[nextClassIndex - 1].end)
                        currentDisplayItem = { name: 'After', contentType: 2, ...currentChannel.after };
                    else currentDisplayItem = { name: 'Before', contentType: 0, ...currentChannel.before };

                    this.setState({
                        previousClassIndex: nextClassIndex - 1,
                        nextClassIndex,
                        before: { time: newDisplayBeforeAfterDuration, ...currentChannel.before },
                        after: { time: newDisplayBeforeAfterDuration, ...currentChannel.after },
                        currentDisplayItem,
                    });
                } else {
                    if (classes[nextClassIndex].start - nowTime <= startDisplay)
                        currentDisplayItem = {
                            name: 'Before',
                            ...currentChannel.before,
                            contentType: 0,
                            time: classes[nextClassIndex].start - nowTime,
                        };
                    else
                        currentDisplayItem = {
                            contentType: 3,
                            name: 'Between',
                            ...currentChannel.between,
                            time: classes[nextClassIndex].start - nowTime - startDisplay,
                        };

                    this.setState({
                        previousClassIndex: nextClassIndex - 1,
                        nextClassIndex,
                        before: {
                            time: convertFormatToSeconds(currentChannel.start_display),
                            ...currentChannel.before,
                        },
                        after: { time: convertFormatToSeconds(currentChannel.end_display), ...currentChannel.after },
                        currentDisplayItem,
                    });
                }
            } else if (nextClassIndex === null) {
                this.setState(prevState => ({
                    ...prevState,
                    previousClassIndex,
                    before: { time: convertFormatToSeconds(currentChannel.start_display), ...currentChannel.before },
                    after: { time: convertFormatToSeconds(currentChannel.end_display), ...currentChannel.after },
                    during: { ...currentChannel.during },
                    currentDisplayItem: {
                        name: 'Between',
                        contentType: 3,
                        ...currentChannel.between,
                        // time: classes[currentClassIndex].end - nowTime
                    },
                }));
            } else if (nextClassIndex === 0) {
                if (classes[nextClassIndex].start - nowTime <= startDisplay) {
                    this.setState(prevState => ({
                        ...prevState,
                        previousClassIndex,
                        nextClassIndex,
                        before: { time: classes[nextClassIndex].start - nowTime, ...currentChannel.before },
                        after: { time: endDisplay, ...currentChannel.after },
                        during: { ...currentChannel.during },
                        currentDisplayItem: {
                            name: 'Before',
                            contentType: 0,
                            ...currentChannel.before,
                        },
                    }));
                } else {
                    this.setState(prevState => ({
                        ...prevState,
                        previousClassIndex,
                        nextClassIndex,
                        before: {
                            time: convertFormatToSeconds(currentChannel.start_display),
                            ...currentChannel.before,
                        },
                        after: { time: convertFormatToSeconds(currentChannel.end_display), ...currentChannel.after },
                        during: { ...currentChannel.during },
                        currentDisplayItem: {
                            name: 'Between',
                            contentType: 3,
                            ...currentChannel.between,
                        },
                    }));
                }
            }
        }
    };

    checkClassDisplay = () => {
        const { classes, currentChannel } = this.props;
        const { nextClassIndex, currentClassIndex, previousClassIndex } = this.state;
        const nowTime = getCurrentTimestamp();
        const startDisplay = convertFormatToSeconds(currentChannel.start_display);
        const endDisplay = convertFormatToSeconds(currentChannel.end_display);
        let currentDisplayItem = {};

        /*
            Transition from DURING to AFTER
        */
        if (currentClassIndex || currentClassIndex === 0) {
            const isClassEnded = classes[currentClassIndex].end <= nowTime;
            // let shouldResumePreviousClass = false;
            // if (previousClassIndex || previousClassIndex === 0)
            //     if (classes[previousClassIndex].end < nowTime) shouldResumePreviousClass = true;

            // if (isClassEnded && shouldResumePreviousClass) {
            //     this.setState(prevState => ({
            //         ...prevState,
            //         currentClassIndex: previousClassIndex,
            //         previousClassIndex: currentClassIndex,
            //         nextClassIndex: currentClassIndex + 2,

            //     }))
            // }

            if (isClassEnded && nextClassIndex) {
                const differenceInTimeBetweenClasses = classes[nextClassIndex].start - classes[currentClassIndex].end;
                const beforeAfterDisplayDuration =
                    convertFormatToSeconds(currentChannel.start_display) +
                    convertFormatToSeconds(currentChannel.end_display);

                if (differenceInTimeBetweenClasses < beforeAfterDisplayDuration) {
                    const newDisplayBeforeAfterDuration = (beforeAfterDisplayDuration / 2).toFixed(0);
                    currentDisplayItem = {
                        name: 'After',
                        time: newDisplayBeforeAfterDuration,
                        contentType: 2,
                        ...currentChannel.after,
                    };

                    this.setState({
                        before: { time: newDisplayBeforeAfterDuration, ...currentChannel.before },
                        after: { time: newDisplayBeforeAfterDuration, ...currentChannel.after },
                        previousClassIndex: currentClassIndex,
                        currentClassIndex: null,
                        currentDisplayItem,
                    });
                } else {
                    currentDisplayItem = { name: 'After', contentType: 2, time: endDisplay, ...currentChannel.after };

                    this.setState({
                        before: { time: startDisplay, ...currentChannel.before },
                        after: { time: endDisplay, ...currentChannel.after },
                        previousClassIndex: currentClassIndex,
                        currentClassIndex: null,
                        currentDisplayItem,
                    });
                }
            } else if (isClassEnded && !nextClassIndex) {
                currentDisplayItem = { name: 'After', contentType: 2, time: endDisplay, ...currentChannel.after };
                this.setState({
                    before: { time: startDisplay, ...currentChannel.before },
                    after: { time: endDisplay, ...currentChannel.after },
                    previousClassIndex: currentClassIndex,
                    currentClassIndex: null,
                    currentDisplayItem,
                });
            }
        } else {
            /*
                Transition from BEFORE to DURING
            */
            if (this.state.currentDisplayItem.name === 'Before') {
                if (classes[nextClassIndex].start <= nowTime) {
                    let nextClass = null;
                    if (classes.length > nextClassIndex + 1) nextClass = nextClassIndex + 1;
                    this.setState({
                        currentClassIndex: nextClassIndex,
                        nextClassIndex: nextClass,
                        currentDisplayItem: {
                            name: 'During',
                            contentType: 1,
                            time: classes[nextClassIndex].end - classes[nextClassIndex].start,
                            ...currentChannel.during,
                        },
                    });
                }
            }

            if (this.state.currentDisplayItem.name === 'After') {
                /*
                    Transition from AFTER to BEFORE
                */
                if (
                    (previousClassIndex || previousClassIndex === 0) &&
                    nowTime - classes[previousClassIndex].end >= endDisplay
                ) {
                    if (nextClassIndex && this.state.after.time <= endDisplay) {
                        this.setState({
                            currentDisplayItem: {
                                name: 'Before',
                                contentType: 0,
                                // time: classes[nextClassIndex].start - nowTime,
                                ...currentChannel.before,
                            },
                        });
                    } else {
                        /*
                            Transition from AFTER to BETWEEN
                        */
                        this.setState({
                            currentDisplayItem: {
                                name: 'Between',
                                contentType: 3,
                                // time: classes[nextClassIndex].start - nowTime - startDisplay,
                                ...currentChannel.between,
                            },
                        });
                    }
                }
            }

            /*
                Transition from BETWEEN to BEFORE
            */
            if (this.state.currentDisplayItem.name === 'Between') {
                if (nextClassIndex && classes[nextClassIndex].start - nowTime <= this.state.before.time) {
                    this.setState({
                        currentDisplayItem: {
                            name: 'Before',
                            contentType: 0,
                            time: classes[nextClassIndex].start - nowTime,
                            ...currentChannel.before,
                        },
                    });
                }
            }

            /*
                    Transition from during to during
                */
            if (this.state.currentDisplayItem.name === 'During') {
                if (nextClassIndex && classes[nextClassIndex].start <= nowTime) {
                    const nextIndex = nextClassIndex ? nextClassIndex + 1 : null;

                    this.setState(prevState => ({
                        ...prevState,
                        previousClassIndex: currentClassIndex,
                        currentClassIndex: nextClassIndex,
                        nextClassIndex: nextIndex,
                        a: 'aaa',
                        currentDisplayItem: {
                            name: 'During',
                            contentType: 3,
                            time: classes[nextClassIndex].end - nowTime,
                            ...currentChannel.during,
                        },
                    }));
                }
            }
        }
    };

    render() {
        const {
            props: { classesLoading, currentChannelLoading, currentChannel, classes },
            state: { currentClassIndex, currentDisplayItem, previousClassIndex, nextClassIndex },
        } = this;
        const currentClass = currentClassIndex !== null ? classes[currentClassIndex] : {};
        let workoutId,
            contentType,
            leaderboardIds = [],
            youtubeLink,
            contentTypes = [],
            youtubeLinks = [],
            workoutIds = [],
            isDarkeningLayerApplied;

        if (currentClass.workout) workoutId = currentClass.workout.data.id;
        isDarkeningLayerApplied = currentChannel.layer;

        if (!isEmptyObject(currentDisplayItem) && currentDisplayItem.data) {
            contentType = currentDisplayItem.data.content_type;
            if (currentDisplayItem.contentType === 3) {
                contentTypes = currentDisplayItem.data.map(item => item.content_type);

                currentDisplayItem.data.forEach((item, index) => {
                    if (item.leaderboards) {
                        leaderboardIds.push([]);
                        item.leaderboards.data.forEach(lb => leaderboardIds[index].push(lb.id));
                    } else leaderboardIds.push([]);
                });

                currentDisplayItem.data.forEach(item => {
                    if (item.youtube_link) youtubeLinks.push(convertWatchYoutubeLinkToEmbed(item.youtube_link));
                    else youtubeLinks.push([]);
                });

                currentDisplayItem.data.forEach((item, index) => {
                    if (item.workout_id) workoutIds.push(item.workout_id);
                    else workoutIds.push([]);
                });
            }
            workoutId = 7341;
            youtubeLink = convertWatchYoutubeLinkToEmbed(currentDisplayItem.data.youtube_link);
            if (currentDisplayItem.data.leaderboards)
                leaderboardIds = [...currentDisplayItem.data.leaderboards.data.map(lb => lb.id)];

            if (previousClassIndex && currentDisplayItem.contentType === 2 && classes[previousClassIndex].workout)
                workoutId = classes[previousClassIndex].workout.data.id;
            if (nextClassIndex && currentDisplayItem.contentType === 0 && classes[nextClassIndex].workout)
                workoutId = classes[nextClassIndex].workout.data.id;
        }

        return (
            <Container>
                <Loading isLoading={classesLoading || currentChannelLoading}>
                    {currentDisplayItem.contentType === modalTypes.BETWEEN_CLASSES ? (
                        <BetweenSlider
                            contentTypes={contentTypes}
                            contentType={contentType}
                            youtubeLinks={youtubeLinks}
                            workoutIds={workoutIds}
                            workoutId={workoutId}
                            leaderboardIds={leaderboardIds}
                            between={currentDisplayItem.data}
                            duration={currentChannel.rotation_duration}
                            currentChannel={currentChannel}
                        />
                    ) : (
                        <Fragment>
                            {workoutId && contentType === 0 && <WorkoutProgramme currentWorkoutId={workoutId} />}
                            {workoutId && contentType === 1 && <GymTv currentWorkoutId={workoutId} />}
                            {workoutId && contentType === 2 && <RepeatWorkout currentWorkoutId={workoutId} />}
                            {contentType === 3 && (
                                <LeaderBoardsCarusel
                                    background={currentChannel.background}
                                    isDarkeningLayerApplied={isDarkeningLayerApplied}
                                    currentLbIds={[...leaderboardIds]}
                                />
                            )}
                            {contentType === 4 && (
                                <LeaderBoardsCarusel
                                    background={currentChannel.background}
                                    isDarkeningLayerApplied={isDarkeningLayerApplied}
                                    currentLbIds={[...leaderboardIds]}
                                />
                            )}
                            {contentType === 5 && <YoutubePlayer url={youtubeLink} />}
                        </Fragment>
                    )}
                </Loading>
            </Container>
        );
    }
}

const mapStateToProps = ({
    gymTv: {
        statuses: { currentChannelLoading, classesLoading },
        currentChannel,
        classes,
    },
}) => ({
    currentChannelLoading,
    classesLoading,
    currentChannel,
    classes,
});

const mapDispatchToProps = dispatch => ({
    getCurrentChannel: (channelId, callback) =>
        dispatch(GymTvActionCreators.getGymTvChannelByIdRequest(channelId, callback)),
    getClassesByRoomNumber: (roomNumber, callback) =>
        dispatch(GymTvActionCreators.getGymTvClassesByRoomNumberRequest(roomNumber, callback)),
});

export default compose(
    withCurrentTime,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(GymTvChannelDisplay);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/ChannelDisplay/index.js